import { Component, output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';

@Component({
  selector: 'app-filtri-donchian',
  standalone: true,
  imports: [ReactiveFormsModule, MdbFormsModule, MdbSelectModule,
    FormsModule
  ],
  templateUrl: './filtri-donchian.component.html',
  styleUrl: './filtri-donchian.component.scss'
})
export class FiltriDonchianComponent {
  params = output<any>();
  params2 = output<any>();
  impostaVolume = output<any>();

  listaAnni: number[] = [2024, 2023, 2022, 2021, 2020, 2019]

  formFiltri: FormGroup = new FormGroup({
    daAnno: new FormControl(2021),
    fotsi2: new FormControl(true),
    media: new FormControl(50),
    donchian: new FormControl(10),
    takeprofit: new FormControl(0.9),
    weekday: new FormGroup(
      {
        lun: new FormControl(true),
        mar: new FormControl(true),
        mer: new FormControl(true),
        gio: new FormControl(true),
        ven: new FormControl(true),
      }
    ),
    weekdayBuy: new FormGroup(
      {
        lun: new FormControl(true),
        mar: new FormControl(true),
        mer: new FormControl(true),
        gio: new FormControl(true),
        ven: new FormControl(true),
      }
    ),
    weekdaySell: new FormGroup(
      {
        lun: new FormControl(true),
        mar: new FormControl(true),
        mer: new FormControl(true),
        gio: new FormControl(true),
        ven: new FormControl(true),
      }
    ),
    mesi: new FormGroup(
      {
        gen: new FormControl(true),
        feb: new FormControl(true),
        marzo: new FormControl(true),
        apr: new FormControl(true),
        mag: new FormControl(true),
        giu: new FormControl(true),
        lug: new FormControl(true),
        ago: new FormControl(true),
        set: new FormControl(true),
        ott: new FormControl(true),
        nov: new FormControl(true),
        dic: new FormControl(true),
      }
    ),
    mesiBuy: new FormGroup(
      {
        gen: new FormControl(true),
        feb: new FormControl(true),
        marzo: new FormControl(true),
        apr: new FormControl(true),
        mag: new FormControl(true),
        giu: new FormControl(true),
        lug: new FormControl(true),
        ago: new FormControl(true),
        set: new FormControl(true),
        ott: new FormControl(true),
        nov: new FormControl(true),
        dic: new FormControl(true),
      }
    ),
    mesiSell: new FormGroup(
      {
        gen: new FormControl(true),
        feb: new FormControl(true),
        marzo: new FormControl(true),
        apr: new FormControl(true),
        mag: new FormControl(true),
        giu: new FormControl(true),
        lug: new FormControl(true),
        ago: new FormControl(true),
        set: new FormControl(true),
        ott: new FormControl(true),
        nov: new FormControl(true),
        dic: new FormControl(true),
      }
    ),
    orari: new FormGroup(
      {
        ora0: new FormControl(true),
        ora1: new FormControl(true),
        ora2: new FormControl(true),
        ora3: new FormControl(true),
        ora4: new FormControl(true),
        ora5: new FormControl(true),
        ora6: new FormControl(true),
        ora7: new FormControl(true),
        ora8: new FormControl(true),
        ora9: new FormControl(true),
        ora10: new FormControl(true),
        ora11: new FormControl(true),
        ora12: new FormControl(true),
        ora13: new FormControl(true),
        ora14: new FormControl(true),
        ora15: new FormControl(true),
        ora16: new FormControl(true),
        ora17: new FormControl(true),
        ora18: new FormControl(true),
        ora19: new FormControl(true),
        ora20: new FormControl(true),
        ora21: new FormControl(true),
        ora22: new FormControl(true),
        ora23: new FormControl(true),
      }),
    orariBuy: new FormGroup(
      {
        ora0: new FormControl(true),
        ora1: new FormControl(true),
        ora2: new FormControl(true),
        ora3: new FormControl(true),
        ora4: new FormControl(true),
        ora5: new FormControl(true),
        ora6: new FormControl(true),
        ora7: new FormControl(true),
        ora8: new FormControl(true),
        ora9: new FormControl(true),
        ora10: new FormControl(true),
        ora11: new FormControl(true),
        ora12: new FormControl(true),
        ora13: new FormControl(true),
        ora14: new FormControl(true),
        ora15: new FormControl(true),
        ora16: new FormControl(true),
        ora17: new FormControl(true),
        ora18: new FormControl(true),
        ora19: new FormControl(true),
        ora20: new FormControl(true),
        ora21: new FormControl(true),
        ora22: new FormControl(true),
        ora23: new FormControl(true),
      }),
    orariSell: new FormGroup(
      {
        ora0: new FormControl(true),
        ora1: new FormControl(true),
        ora2: new FormControl(true),
        ora3: new FormControl(true),
        ora4: new FormControl(true),
        ora5: new FormControl(true),
        ora6: new FormControl(true),
        ora7: new FormControl(true),
        ora8: new FormControl(true),
        ora9: new FormControl(true),
        ora10: new FormControl(true),
        ora11: new FormControl(true),
        ora12: new FormControl(true),
        ora13: new FormControl(true),
        ora14: new FormControl(true),
        ora15: new FormControl(true),
        ora16: new FormControl(true),
        ora17: new FormControl(true),
        ora18: new FormControl(true),
        ora19: new FormControl(true),
        ora20: new FormControl(true),
        ora21: new FormControl(true),
        ora22: new FormControl(true),
        ora23: new FormControl(true),
      }),
  })
  listaTP: number[] = [0, 0.9, 1.0, 1.2, 1.38, 1.5, 1.62, 1.8, 2.0, 2.2, 2.62, 3.0, 3.62, 4.62, 5.62]
  sogliaProfitto: string = ''
  volumeVariabile: boolean = false
  oldFiltri: any = {}
  formModificato: boolean = false

  ngOnInit() {
    this.formFiltri.valueChanges.subscribe(form => {
      if(this.formModificato){
        this.formModificato = false
        return
      }
      this.verificaFiltriModificati()
      this.oldFiltri = form
      this.params2.emit(form)
      this.calcolaPercentualeSoglia(this.formFiltri.get('takeprofit')?.value)
    })
    this.calcolaPercentualeSoglia(this.formFiltri.get('takeprofit')?.value)
    this.oldFiltri = this.formFiltri.value
  }

  resetFiltri(forex: boolean = true) {
    let crossT = forex ? true : false
    this.formFiltri.get('fotsi2')?.setValue(crossT)
    this.formFiltri.reset({
      daAnno: this.formFiltri.get('daAnno')?.value,
      fotsi2: crossT,
      media: this.formFiltri.get('media')?.value,
      donchian: this.formFiltri.get('donchian')?.value,
      takeprofit: this.formFiltri.get('takeprofit')?.value,
      weekday: {
        lun: true,
        mar: true,
        mer: true,
        gio: true,
        ven: true,
      },
      weekdayBuy: {
        lun: true,
        mar: true,
        mer: true,
        gio: true,
        ven: true,
      },
      weekdaySell: {
        lun: true,
        mar: true,
        mer: true,
        gio: true,
        ven: true,
      },
      mesi: {
        gen: true,
        feb: true,
        marzo: true,
        apr: true,
        mag: true,
        giu: true,
        lug: true,
        ago: true,
        set: true,
        ott: true,
        nov: true,
        dic: true,
      },
      mesiBuy: {
        gen: true,
        feb: true,
        marzo: true,
        apr: true,
        mag: true,
        giu: true,
        lug: true,
        ago: true,
        set: true,
        ott: true,
        nov: true,
        dic: true,
      },
      mesiSell: {
        gen: true,
        feb: true,
        marzo: true,
        apr: true,
        mag: true,
        giu: true,
        lug: true,
        ago: true,
        set: true,
        ott: true,
        nov: true,
        dic: true,
      },
      orari: {
        ora0: true,
        ora1: true,
        ora2: true,
        ora3: true,
        ora4: true,
        ora5: true,
        ora6: true,
        ora7: true,
        ora8: true,
        ora9: true,
        ora10: true,
        ora11: true,
        ora12: true,
        ora13: true,
        ora14: true,
        ora15: true,
        ora16: true,
        ora17: true,
        ora18: true,
        ora19: true,
        ora20: true,
        ora21: true,
        ora22: true,
        ora23: true
      },
      orariBuy: {
        ora0: true,
        ora1: true,
        ora2: true,
        ora3: true,
        ora4: true,
        ora5: true,
        ora6: true,
        ora7: true,
        ora8: true,
        ora9: true,
        ora10: true,
        ora11: true,
        ora12: true,
        ora13: true,
        ora14: true,
        ora15: true,
        ora16: true,
        ora17: true,
        ora18: true,
        ora19: true,
        ora20: true,
        ora21: true,
        ora22: true,
        ora23: true
      },
      orariSell: {
        ora0: true,
        ora1: true,
        ora2: true,
        ora3: true,
        ora4: true,
        ora5: true,
        ora6: true,
        ora7: true,
        ora8: true,
        ora9: true,
        ora10: true,
        ora11: true,
        ora12: true,
        ora13: true,
        ora14: true,
        ora15: true,
        ora16: true,
        ora17: true,
        ora18: true,
        ora19: true,
        ora20: true,
        ora21: true,
        ora22: true,
        ora23: true
      }
    })
    this.oldFiltri = this.formFiltri.value
  }

  annullaFiltri() {
    this.formFiltri.reset({
      daAnno: this.formFiltri.get('daAnno')?.value,
      fotsi2: this.formFiltri.get('fotsi2')?.value,
      media: this.formFiltri.get('media')?.value,
      donchian: this.formFiltri.get('donchian')?.value,
      takeprofit: this.formFiltri.get('takeprofit')?.value,
      weekday: {
        lun: false,
        mar: false,
        mer: false,
        gio: false,
        ven: false,
      },
      weekdayBuy: {
        lun: false,
        mar: false,
        mer: false,
        gio: false,
        ven: false,
      },
      weekdaySell: {
        lun: false,
        mar: false,
        mer: false,
        gio: false,
        ven: false,
      },
      mesi: {
        gen: false,
        feb: false,
        marzo: false,
        apr: false,
        mag: false,
        giu: false,
        lug: false,
        ago: false,
        set: false,
        ott: false,
        nov: false,
        dic: false,
      },
      mesiBuy: {
        gen: false,
        feb: false,
        marzo: false,
        apr: false,
        mag: false,
        giu: false,
        lug: false,
        ago: false,
        set: false,
        ott: false,
        nov: false,
        dic: false,
      },
      mesiSell: {
        gen: false,
        feb: false,
        marzo: false,
        apr: false,
        mag: false,
        giu: false,
        lug: false,
        ago: false,
        set: false,
        ott: false,
        nov: false,
        dic: false,
      },
      orari: {
        ora0: false,
        ora1: false,
        ora2: false,
        ora3: false,
        ora4: false,
        ora5: false,
        ora6: false,
        ora7: false,
        ora8: false,
        ora9: false,
        ora10: false,
        ora11: false,
        ora12: false,
        ora13: false,
        ora14: false,
        ora15: false,
        ora16: false,
        ora17: false,
        ora18: false,
        ora19: false,
        ora20: false,
        ora21: false,
        ora22: false,
        ora23: false
      },
      orariBuy: {
        ora0: false,
        ora1: false,
        ora2: false,
        ora3: false,
        ora4: false,
        ora5: false,
        ora6: false,
        ora7: false,
        ora8: false,
        ora9: false,
        ora10: false,
        ora11: false,
        ora12: false,
        ora13: false,
        ora14: false,
        ora15: false,
        ora16: false,
        ora17: false,
        ora18: false,
        ora19: false,
        ora20: false,
        ora21: false,
        ora22: false,
        ora23: false
      },
      orariSell: {
        ora0: false,
        ora1: false,
        ora2: false,
        ora3: false,
        ora4: false,
        ora5: false,
        ora6: false,
        ora7: false,
        ora8: false,
        ora9: false,
        ora10: false,
        ora11: false,
        ora12: false,
        ora13: false,
        ora14: false,
        ora15: false,
        ora16: false,
        ora17: false,
        ora18: false,
        ora19: false,
        ora20: false,
        ora21: false,
        ora22: false,
        ora23: false
      }
    })
    this.oldFiltri = this.formFiltri.value
  }

  get weekday() {
    return this.formFiltri.get('weekday') as FormGroup;
  }

  get weekdayBuy() {
    return this.formFiltri.get('weekdayBuy') as FormGroup;
  }
  get weekdaySell() {
    return this.formFiltri.get('weekdaySell') as FormGroup;
  }

  get mesi() {
    return this.formFiltri.get('mesi') as FormGroup;
  }
  get mesiBuy() {
    return this.formFiltri.get('mesiBuy') as FormGroup;
  }
  get mesiSell() {
    return this.formFiltri.get('mesiSell') as FormGroup;
  }

  get orari() {
    return this.formFiltri.get('orari') as FormGroup;
  }
  get orariBuy() {
    return this.formFiltri.get('orariBuy') as FormGroup;
  }
  get orariSell() {
    return this.formFiltri.get('orariSell') as FormGroup;
  }

  calcolaPercentualeSoglia(tp: any) {
    tp = parseFloat(tp)
    if (tp == 0) {
      this.sogliaProfitto = 'Nessun takeprofit'
      return
    }
    let percentualeSoglia = 1 / (tp + 1) * 100
    this.sogliaProfitto = percentualeSoglia.toFixed(2) + '% per takeprofit: ' + tp
  }

  filtra() {
    console.log(this.formFiltri)
    this.params.emit(this.formFiltri.value)
  }

  impostaVolumeVariabile(event: any) {
    this.impostaVolume.emit(event.target.checked)
  }

  verificaFiltriModificati() {
    let k1 = Object.keys(this.oldFiltri.weekday)
    let k2 = Object.keys(this.formFiltri.value.weekday)
    for (let k of k1) {
      if (this.oldFiltri.weekday[k] != this.formFiltri.value.weekday[k]) {
        this.oldFiltri.weekday[k] = this.formFiltri.value.weekday[k]
        let f = this.formFiltri.get('weekdayBuy')
        if (f) {
          this.oldFiltri.weekdayBuy[k] = this.formFiltri.value.weekday[k]
          this.formModificato = true
          f.get(k)?.setValue(this.formFiltri.value.weekday[k])
        }
        f = this.formFiltri.get('weekdaySell')
        if (f) {
          this.oldFiltri.weekdaySell[k] = this.formFiltri.value.weekday[k]
          this.formModificato = true
          f.get(k)?.setValue(this.formFiltri.value.weekday[k])
        }
      }
    }
  }

}
